// extracted by mini-css-extract-plugin
export default {"modalOverlay":"mA-z","modalContent":"nA-z","header":"oA-z","close":"pA-z"};